import React from 'react'
import {useForm} from 'react-hook-form'
import {SimpleBlog, useSimpleBlogUpdate} from 'Event/template/SimpleBlog'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import Settings from 'Event/template/SimpleBlog/ImageWaterfall/ImageWaterfallConfig/Settings'
import Styling from 'Event/template/SimpleBlog/ImageWaterfall/ImageWaterfallConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'

export default function SimpleBlogImageWaterfallConfig(
  props: ComponentConfigProps,
) {
  const {showing: isVisible, onClose} = props

  const {control, register, handleSubmit, formState} = useForm()

  const updateTemplate = useSimpleBlogUpdate()

  const submit = (data: SimpleBlog['imageWaterfall']) => {
    updateTemplate({
      imageWaterfall: data,
    })

    props.onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Image Waterfall"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
